import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGridBox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGridBox"><Path d="M9.10156 4V20" stroke="currentColor"/><Path d="M14.8984 4V20" stroke="currentColor"/><Path d="M4 9.1001H20" stroke="currentColor"/><Path d="M4 14.8999H20" stroke="currentColor"/><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconGridBox;
